/** @jsxImportSource @emotion/react */
import React, { PropsWithChildren } from 'react';
import { jsx, css } from '@emotion/react';
import { Grid, GridColumn } from '@atlaskit/page';

const defaultProps = {
};

type Props = {
  header: React.ReactNode
} & typeof defaultProps;

const containerStyles = css`
    padding: 0px ${40}px;
  `;

const TablePage = ({header, children}: PropsWithChildren<Props>) => {

  return (
    <div css={css`
        height: 100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;
      `}>
    <div>
      <Grid layout="fluid" spacing="comfortable">
        <GridColumn>
          {header}
        </GridColumn>
      </Grid>
    </div>
    <div css={css`
        padding-top: 0px;
        flex: 1;
        display: flex;
        flex-direction: column;
        ${containerStyles};
        table {
          flex: 1;
            position: absolute;
            height: 100%;
            width: 100%;
        }
        table tbody {
          overflow: auto;
        }
       `}>
    {children}
    </div>
  </div>);
};

TablePage.defaultProps = defaultProps;

export default TablePage;
